<template>
  <div>
    <v-alert
      type="info"
      border="left"
      flat
      class="mb-2 pb-2"
    >
      <v-skeleton-loader
        type="text"
      />
      <v-skeleton-loader
        type="text"
        class="mt-2"
      />
    </v-alert>

    <v-card
      flat
    >
      <v-card-text>
        <v-skeleton-loader type="card" />
      </v-card-text>
    </v-card>

    <v-card
      class="my-2"
      flat
    >
      <v-card-text>
        <v-skeleton-loader type="card" />
        <v-row>
          <v-spacer />
          <v-skeleton-loader
            type="image"
            width="300px"
            height="40px"
          />
          <v-spacer />
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FlightPassengersInformationLoader'
}
</script>

<style scoped>
</style>
